export default "__VITE_ASSET__DNMHC$Iv__"